export const MENU_NAV_LANGUAGES = ['en', 'fr', 'de'] as const

export const MENU_LOCATIONS = [
  'main',
  'footer_col1',
  'footer_col2',
  'footer_col3',
  'mobile',
] as const

export type MenuLocation = (typeof MENU_LOCATIONS)[number]

export interface MenuItemTranslation {
  _id?: string
  menuItem_id?: string
  language: string
  label: string
}

export interface MenuItem {
  _id: string
  label: string
  url: string
  target?: '_self' | '_blank'
  position: number
  parent?: string | null
  location: MenuLocation | string
  isActive: boolean
  translations?: MenuItemTranslation[]
  icon?: string
  openInNewTab?: boolean
}

export function displayLabel(item: MenuItem, lang: string): string {
  const tr = item.translations?.find((t) => t.language === lang)
  return tr?.label ?? item.label ?? ''
}

export function mergeTranslations(
  existing: MenuItemTranslation[] | undefined,
  lang: string,
  label: string,
): { language: string; label: string }[] {
  const map = new Map<string, string>()
  for (const t of existing || []) {
    map.set(t.language, t.label)
  }
  map.set(lang, label)
  return Array.from(map.entries()).map(([language, l]) => ({ language, label: l }))
}

export function isExternalUrl(url: string): boolean {
  return /^https?:\/\//i.test((url || '').trim())
}

export function parentKey(p: string | null | undefined): string {
  if (p == null || p === '') return ''
  return typeof p === 'object' ? String((p as any)._id || p) : String(p)
}

export function getSiblings(all: MenuItem[], item: MenuItem): MenuItem[] {
  const pk = parentKey(item.parent as string | null)
  return all
    .filter(
      (i) =>
        i.location === item.location && parentKey(i.parent as string | null) === pk,
    )
    .sort((a, b) => a.position - b.position)
}

export function collectDescendantIds(rootId: string, all: MenuItem[]): Set<string> {
  const out = new Set<string>()
  const walk = (id: string) => {
    for (const m of all) {
      if (parentKey(m.parent as string | null) === id) {
        out.add(m._id)
        walk(m._id)
      }
    }
  }
  walk(rootId)
  return out
}
